import ReactGA from 'react-ga';
import React, { Component } from 'react'
import BigCalendar from 'react-big-calendar'
import moment from "moment"
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { Button, Checkbox } from 'antd'
import { Client } from 'fulcrum-app'
import './index.css'
import CollectionCreateForm from './createEvent'
import CollectionEditForm from './editEvent'

const localizer = BigCalendar.momentLocalizer(moment)
const client = new Client(process.env.REACT_APP_SECRET_KEY)

export default class Dev extends Component {
	constructor(){
		super();
		this.state = {
			createEvtModal: false,
			editEvtModal: false,
			events: [],
			showJobEvents:false,
			jobEvents: [],
			selectedEvent: {
				id: '',
				title: '',
				color: '',
				desc: '',
				start: '',
				end: ''
			},
			loading: false,
			loadingUpdate: false,
			selectedRange: null
		}
		this.addJobs = this.addJobs.bind(this)
	}
	componentDidUpdate(prevProps) {
		if (prevProps.events !== this.props.events) {
			this.setState({
				events: [],
				jobEvents: [],
			}, () => this.loadEvents())
		}
	}
	loadEvents() {
		this.props.events.forEach((r) => {
			let ent = r.form_values;
			if (ent['9077']) {
				var col = ent['9077'].choice_values['0'];
			}
			if (ent['839d'] === 'true') {
				var allDay = true
			} else if (ent['839d'] === 'false') {
				allDay = false
			}
			this.setState(prevState => ({
				events: [...prevState.events, {
					id: r.id,
					title: ent['81f1'],
					color: col,
					desc: ent['aff0'],
					start: moment(ent['5bbd'] + " " + ent['840e'], 'YYYY-MM-DD HH:mm').toDate(),
					end: moment(ent['887d'] + " " + ent['edcd'], 'YYYY-MM-DD HH:mm').toDate(),
					allDay: allDay
				}]
			}))
		})
		this.loadCalendarEvents()
	}
	componentDidMount() {
		ReactGA.pageview('/calendar');
		this.loadEvents()
	}
	showModal = (e, selected) => {
		if (e === 'createEvent') {
			this.setState({
				createEvtModal: true,
				selectedRange: selected
			});

		} else if (e === 'editEvtModal') {
			this.setState({
				editEvtModal: true
			});
		}
	}
	handleCancel = (e) => {
		if (e === 'createEvent') {
			this.setState({
				createEvtModal: false,
				selectedRange: null
			});
		} else if (e === 'editEvtModal') {
			this.setState({
				editEvtModal: false,
				selectedEvent: {
					id: '',
					title: '',
					color: '',
					desc: '',
					start: '',
					end: ''
				}
			})
		}
	}
	handleCreate = () => {
		const form = this.formRef.props.form;
		form.validateFields((err, values) => {
			if (err) { return }
			var obj = {
				form_id: 'ff9b40a4-61e0-46fb-a592-48a8f90e2d4d',
				form_values: {
					'5bbd': moment(values.range[0]).format('YYYY-MM-DD'),
					'81f1': values.title,
					'840e': moment(values.range[0]).format('HH:mm'),
					'887d': moment(values.range[1]).format('YYYY-MM-DD'),
					'9077': {
						choice_values: [
							values.color
						]
					},
					'839d': values.allDay.toString(),
					'aff0': values.description,
					'edcd': moment(values.range[1]).format('HH:mm')
				}
			}

			client.records.create(obj).then((status) => {
				this.setState(prevState => ({
					events: [...prevState.events, {
						id: status.id,
						title: values.title,
						color: values.color,
						desc: values.description,
						start: moment(values.range[0]).toDate(),
						end: moment(values.range[1]).toDate(),
						allDay: values.allDay
					}]
				}))
				ReactGA.event({
					category: this.props.user.username,
					action: 'Created calendar event'
				});
			}).catch((err) => {
				console.log(err);
			})

			form.resetFields();
			this.setState({ createEvtModal: false });
		});
	}
	handleUpdate = () => {
		const editForm = this.formRefEdit.props.form;
		this.setState({ loadingUpdate: true })
		editForm.validateFields((err, values) => {
			if (err) { return }
			var obj = {
				form_id: 'ff9b40a4-61e0-46fb-a592-48a8f90e2d4d',
				form_values: {
					'5bbd': moment(values.range[0]).format('YYYY-MM-DD'),
					'81f1': values.title,
					'840e': moment(values.range[0]).format('HH:mm'),
					'887d': moment(values.range[1]).format('YYYY-MM-DD'),
					'9077': {
						choice_values: [
							values.color
						]
					},
					'839d': values.allDay.toString(),
					'aff0': values.description,
					'edcd': moment(values.range[1]).format('HH:mm')
				},
				id: values.id
			}
			client.records.update(obj.id, obj).then((status) => {
				for (let k = 0; k < this.state.events.length; k++) {
					if (this.state.events[k].id === values.id) {
						this.setState((prevState) => ({
							events: prevState.events.filter((_, i) => i !== k)
						}))
					}
				}

			})
				.then(() => {
					this.setState(prevState => ({
						events: [...prevState.events, {
							id: values.id,
							title: values.title,
							color: values.color,
							desc: values.description,
							start: moment(values.range[0]).toDate(),
							end: moment(values.range[1]).toDate(),
							allDay: values.allDay
						}]
					}))
					ReactGA.event({
						category: this.props.user.username,
						action: 'Edited calendar event'
					});
				})
				.catch((err) => {
					console.log(err);
				})
			setTimeout(() => {
				this.setState({ loadingUpdate: false, editEvtModal: false });
			}, 1250);

			editForm.resetFields();
		});
	}
	handleDelete = () => {
		const form = this.formRefEdit.props.form;
		form.validateFields((err, values) => {
			if (err) { return }

			this.setState({ loading: true })
			client.records.delete(values.id)
				.then(status => {
					for (let k = 0; k < this.state.events.length; k++) {
						if (this.state.events[k].id === values.id) {
							this.setState((prevState) => ({
								events: prevState.events.filter((_, i) => i !== k)
							}));
						}
					}
					ReactGA.event({
						category: this.props.user.username,
						action: 'Deleted calendar event'
					});
				}).catch(err => console.log(err))
			setTimeout(() => {
				this.setState({ loading: false, editEvtModal: false });
			}, 1250);

			form.resetFields();
		});
	}
	saveFormRef = (formRef) => {
		this.formRef = formRef;
	}
	saveFormRefEdit = (formRef) => {
		this.formRefEdit = formRef;
	}
	eventStyleGetter(event, start, end, isSelected) {
		//https://color.adobe.com/Flat-rainbow-color-theme-3012612/edit/?copy=true&base=2&rule=Custom&selected=2&name=Copy%20of%20Flat%20rainbow&mode=rgb&rgbvalues=0.945098,0.352941,0.352941,0.941176,0.768627,0.0980392,0.305882,0.729412,0.435294,0.176471,0.584314,0.74902,0.584314,0.356863,0.647059&swatchOrder=0,1,2,3,4
		if (event.color === 'Red') {
			var backgroundColor = 'rgba(255, 99, 132, 0.2)';
			var borderColor = 'rgba(255,99,132,1)';
		} else if (event.color === 'Blue') {
			backgroundColor = 'rgba(54, 162, 235, 0.2)';
			borderColor = 'rgba(54, 162, 235, 1)';
		} else if (event.color === 'Yellow') {
			backgroundColor = 'rgba(255, 206, 86, 0.2)';
			borderColor = 'rgba(255, 206, 86, 1)';
		} else if (event.color === 'Green') {
			backgroundColor = 'rgba(75, 192, 192, 0.2)';
			borderColor = 'rgba(75, 192, 192, 1)';
		} else if (event.color === 'Purple') {
			backgroundColor = 'rgba(153, 102, 255, 0.2)';
			borderColor = 'rgba(153, 102, 255, 1)';
		} else if (event.color === 'Orange') {
			backgroundColor = 'rgba(255, 159, 64, 0.2)';
			borderColor = 'rgba(255, 159, 64, 1)';
		} else {
			backgroundColor = 'rgba(75, 192, 192, 0.2)';
			borderColor = 'rgba(75, 192, 192, 1)'
		}
		var style = {
			backgroundColor: backgroundColor,
			borderRadius: '4px',
			color: 'black',
			display: 'block',
			border: '1px solid ' + borderColor,
		};
		return {
			style: style
		};
	}
	showEvent(e) {
		if (e.desc !== 'clientPortalJobPlot') {
			this.showModal('editEvtModal')
		console.log(e);
		
		if (e.allDay) {
			var allDayshow = e.allDay.toString()
		}
		this.setState({
			selectedEvent: {
				id: e.id,
				title: e.title,
				color: e.color,
				desc: e.desc,
				start: e.start,
				end: e.end,
				allDay: allDayshow
			}
		})
		}
	}
	addJobs(e){
		if (e.target.checked === true) {
			this.setState({showJobEvents: true})
		} else {
			this.setState({showJobEvents: false})
		}
	}
	loadCalendarEvents(){
		this.props.QualityPlans.forEach(record => {
			if (record.form_values['13d3']) {
				if (record.form_values['6f71']) {
					var client = `- ${record.form_values['6f71']}`
				} else {
					client = ''
				}
				if (record.form_values['9ae5']) {
					var driller = `- ${record.form_values['9ae5'].choice_values[0]}`
				} else {
					driller = ''
				}
				if (record.form_values['fb65']) {
					var offsider = `- ${record.form_values['fb65'].choice_values[0]}`
				} else {
					offsider = ''
				}
				if (record.form_values['0a37']) {
					var rig = `- ${record.form_values['0a37'].choice_values[0]}`
				} else {
					rig = ''
				}
				if (client === '- AGL Loy Yang') {
					var color = 'Red'
				} else if (client ==='- Hazelwood Power') {
					color = 'Green'
				} else {
					color = 'Blue'
				}
				
				var jobEvent = {
					id: record.id,
					title: `${record.form_values['c713']} ${client} ${driller} ${offsider} ${rig}`,
					color: color,
					desc: 'clientPortalJobPlot',
					start: moment(record.form_values['af80'], "YYYY-MM-DD").toDate(),
					end: moment(record.form_values['af80'], "YYYY-MM-DD").add(record.form_values['13d3'], 'days').toDate(), 
					allDay: true
				}
				this.setState(prevState => ({
					jobEvents: [...prevState.jobEvents, jobEvent]
				}))		
			}
		})
	}
	render() {
		if (this.state.showJobEvents === true) {
			// var data = this.state.events.concat(this.state.jobEvents)
			var data = this.state.jobEvents
		} else if (this.state.showJobEvents === false) {
			data = this.state.events;
		}		
		return this.props.user.role === 'admin' ?
			<div>
				<Button type="primary" onClick={() => this.showModal('createEvent')} style={{ maxWidth: 207, width: '100%', marginBottom: 10 }}>Create Event</Button>
				<Checkbox onChange={this.addJobs} style={{ margin: '0 20px' }}>Job's</Checkbox>
				<CollectionCreateForm
					wrappedComponentRef={this.saveFormRef}
					visible={this.state.createEvtModal}
					onCancel={() => this.handleCancel('createEvent')}
					onCreate={this.handleCreate}
					selectedRange={this.state.selectedRange}
				/>
				<CollectionEditForm
					wrappedComponentRef={this.saveFormRefEdit}
					visible={this.state.editEvtModal}
					onCancel={() => this.handleCancel('editEvtModal')}
					onUpdate={this.handleUpdate}
					loading={this.state.loading}
					loadingUpdate={this.state.loadingUpdate}
					deleteEvent={this.handleDelete}
					selectedEvent={this.state.selectedEvent}
				/>
				<BigCalendar
					localizer={localizer}
					events={data}
					startAccessor="start"
					endAccessor="end"
					defaultDate={new Date()}
					style={{
						minHeight: 750,
					}}
					showMultiDayTimes
					eventPropGetter={(this.eventStyleGetter)}
					onSelectEvent={(e) => this.showEvent(e)}
					selectable
					onSelectSlot={(selected) => this.showModal('createEvent', selected)}
				/>
			</div>
			:
			<div>
				<h1>Authorised Access Required</h1>
				<h4 style={{ paddingBottom: 10 }}>
					This page is only allowed for 'admin' users.
          </h4>
			</div>

	}
}
